import { EDO } from './columnas';

export const PESTANAS_PM = [['empresa', 'Empresa'], ['accionistas', 'Accionistas'], ['credito', 'Crédito'], ['detalle', 'Detalle'], ['avales', 'Avales'], ['todas', 'Todas']];
const TAB = { EM: 'empresa', AC: 'accionistas', CR: 'credito', DE: 'detalle', AV: 'avales' };
const LISTAS = ['AC', 'AV', 'DE'];
const RANGOS = ['Vigente', '1–29 días', '30–59 días', '60–89 días', '90–119 días', '120–179 días', 'Más de 179 días'];
/*
 * Etiquetas de los catálogos: «código · nombre del Manual Buró Empresas v5 PM» (acortado, sin cambiar el sentido).
 *  TIPO: tipo de persona del renglón (PF, PFAE o PM).
 *  TIPOS_PERSONA: EM23 / AC19 / AV18 (tipo de cliente, de accionista y de aval): 1 = Persona Moral, 2 = Persona Física con Actividad Empresarial.
 *  CR06: catálogo de tipos de crédito (clasificación Banxico).
 *  CR19: Anexo 3 «Claves de Observación» (solo las 4 que usa el sistema).
 */
const TIPO = [['', '—'], ['PF', 'PF · Persona física'], ['PFAE', 'PFAE · Persona física con actividad empresarial'], ['PM', 'PM · Persona moral']];
const TIPOS_PERSONA = [['', '—'], ['1', '1 · Persona moral'], ['2', '2 · Persona física con actividad empresarial']];
const OPCIONES = {
  'CR06': [['', '—'], ['1300', '1300 · Arrendamiento puro'], ['1320', '1320 · Arrendamiento financiero vigente'], ['6270', '6270 · Crédito automotriz']],
  'CR19': [['', '—'], ['VR', 'VR · Dación en pago o Renta'], ['FR', 'FR · Adjudicación y/o aplicación de garantía'], ['UP', 'UP · Cuenta que causa castigo y/o quebranto'], ['CL', 'CL · Cuenta en cobranza pagada totalmente, sin causar quebranto']],
  'EM23': TIPOS_PERSONA.slice(1),
};
// Obligatoriedad que manda el backend en `obligatoria` (R / C / O).
const OBLIGATORIEDAD = { R: 'Obligatorio', C: 'Condicional: Buró lo exige según otros datos', O: 'Opcional' };

/*
 * Ayuda en lenguaje llano para los campos que más confunden: qué es, de dónde
 * sale y cómo lo ve Buró. Clave = id del campo (segmento + etiqueta). Redactado
 * a partir del Manual Buró Empresas v5 (CR) y de cómo lo calcula el backend
 * (ArmadorFilaPm: recuperación de autos). Validar la redacción con Buró.
 */
const AYUDA_PM = {
  CR06: 'Tipo de crédito: clave del catálogo de Buró (clasificación de Banxico). 1300 = Arrendamiento puro; 1320 = Arrendamiento financiero vigente; 6270 = Crédito automotriz. El sistema la sugiere según el tipo de contrato (arrendamiento puro, arrendamiento financiero o crédito simple, que en el catálogo de Buró va como 6270) y queda pendiente de confirmar con Buró.',
  CR12: 'Fecha del último pago que hizo el cliente en este crédito. Sale del último pago registrado en Cartera. Buró la usa para saber qué tan reciente es la actividad; un crédito abierto con saldo debe traerla.',
  CR15: 'Fecha en que el crédito quedó cerrado (liquidado o recuperado). Al reportarla, Buró da la cuenta por cerrada y ya no debe volver a enviarse en meses siguientes.',
  CR16: 'Quita: el importe que se le perdonó o descontó al cliente. Buró lo lee como deuda perdonada (no pagada). En autos recuperados sale del faltante que no cubrió el pago.',
  CR17: 'Dación en pago: el valor del bien (el auto) que el cliente entregó a cuenta del crédito. Sale del valor del auto registrado en la recuperación. Aplica cuando la clave de observación es VR (dación en pago). Buró lo toma como parte del pago.',
  CR18: 'Quebranto o castigo: el saldo que el otorgante no pudo recuperar del cliente. Sale del faltante de la recuperación (deuda menos valor del auto) cuando se perdona. Buró lo registra como pérdida; antes de cerrar hay que confirmar con Buró si ese faltante va como quebranto o como quita.',
  CR19: 'Clave de observación: dice en qué situación quedó el crédito. VR = Dación en pago o Renta: el cliente entregó el bien (el auto) en pago de su deuda. FR = Adjudicación y/o aplicación de garantía: el bien se adjudicó o se aplicó la garantía por falta de pago, mediante juicio. UP = Cuenta que causa castigo y/o quebranto: el saldo no recuperado se reporta como pérdida del otorgante. CL = Cuenta en cobranza pagada totalmente, sin causar quebranto: se mandó a cobranza pero ya se pagó completa. El sistema la deduce del resultado de la recuperación. Si un mes no se envía de nuevo, Buró la borra; para cambiarla se manda la nueva.',
  CR21: 'Fecha del primer incumplimiento: la primera renta que no se pagó a tiempo. Si nunca se atrasó se reporta 00000000 (8 ceros, manual Buró Empresas v5). Obligatoria si hay días de vencimiento. No debe cambiar entre meses.',
  CR22: 'Saldo insoluto: lo que falta por pagar del crédito a la fecha del reporte. Sale de Cartera. En autos recuperados y pagados es 0.',
  EM23: 'Tipo de cliente: 1 = persona moral (empresa), 2 = PFAE (persona física con actividad empresarial). Define el largo del RFC y qué campos de nombre se piden.',
};

const LISTA_COL = {
  AC: { k: '2000', hasta: 2999, num: 'AC', label: 'Accionistas', singular: 'Accionista', lista: 'AC', w: 220 },
  AV: { k: '5000', hasta: 5999, num: 'AV', label: 'Avales', singular: 'Aval', lista: 'AV', w: 220 },
};

// Domicilio por segmento: etiqueta del segmento → rol (verificado en SegmentosPm.php).
// EM: 13 calle, 14 complemento, 15 colonia, 16 municipio, 17 ciudad, 18 estado, 19 C.P.
const DOMICILIO = {
  EM: { 13: 'calle', 14: 'complemento', 15: 'colonia', 16: 'municipio', 17: 'ciudad', 18: 'estado', 19: 'cp' },
  AC: { 9: 'calle', 10: 'complemento', 11: 'colonia', 12: 'municipio', 13: 'ciudad', 14: 'estado', 15: 'cp' },
  AV: { 8: 'calle', 9: 'complemento', 10: 'colonia', 11: 'municipio', 12: 'ciudad', 13: 'estado', 14: 'cp' },
};

/*
 * Claves (código) del domicilio que comparte la columna `c` (la misma empresa o la
 * misma entrada de lista): { calle, complemento, cp, colonia, municipio, ciudad, estado }. null si no es de domicilio.
 * El código de cada columna es base + etiqueta (EM 1000, AC 2000 + 100 × entrada…).
 */
export const clavesDomicilio = (c) => {
  const roles = c && DOMICILIO[c.segmento];
  if (!roles) return null;
  const base = Number(c.k) - Number(c.etiqueta);
  const out = {};
  Object.entries(roles).forEach(([etq, rol]) => { out[rol] = String(base + Number(etq)); });
  return out;
};

/*
 * Mínimo obligatorio de una entrada de lista, en vivo (espeja ValidadorFilaPm.php: persona() y direccion()).
 * `get(etiqueta)` da el valor capturado de esa entrada. Devuelve el Set de etiquetas (números) con *.
 *  AC: tipo (19) y porcentaje (08) siempre; razón social (03) si tipo 1, nombre y apellidos (04, 06, 07)
 *      si tipo 2; RFC (00) si el porcentaje pasa de 10; domicilio completo si se captura algo de 09 a 15.
 *  AV: tipo (18), RFC (00) y domicilio completo siempre; nombre según el tipo.
 *  Domicilio completo: calle, colonia, estado, C.P. y municipio o ciudad (se marcan ambos).
 */
export const obligatoriosLista = (segmento, get) => {
  const av = segmento === 'AV';
  // Etiquetas: tipo, desde-hasta del domicilio (la primera es la calle) y las exigidas por direccion().
  const t = av
    ? { tipo: 18, dom: [8, 14], exigidas: [8, 10, 11, 12, 13, 14] }
    : { tipo: 19, dom: [9, 15], exigidas: [9, 11, 12, 13, 14, 15] };
  const v = (e) => String(get(e) ?? '').trim();
  const out = new Set([t.tipo]);
  if (av || parseInt(v(8), 10) > 10) out.add(0);
  if (!av) out.add(8);
  if (v(t.tipo) === '1') out.add(3);
  if (v(t.tipo) === '2') [4, 6, 7].forEach((e) => out.add(e));
  const capturado = Array.from({ length: t.dom[1] - t.dom[0] + 1 }, (_, i) => t.dom[0] + i).some((e) => v(e) !== '');
  if (av || capturado) t.exigidas.forEach((e) => out.add(e));
  return out;
};

/*
 * Etiquetas del mínimo obligatorio que siguen vacías en una entrada (las que bloquean guardar).
 * `existentes`: etiquetas que la entrada realmente tiene como columna editable.
 * Municipio y ciudad: basta con uno de los dos (el validador pide municipio o ciudad).
 */
export const faltantesLista = (segmento, get, existentes) => {
  const v = (e) => String(get(e) ?? '').trim();
  const [mun, ciu] = segmento === 'AV' ? [11, 12] : [12, 13];
  const unoDeDos = v(mun) !== '' || v(ciu) !== '';
  return [...obligatoriosLista(segmento, get)]
    .filter((e) => existentes.has(e) && v(e) === '' && !(unoDeDos && (e === mun || e === ciu)))
    .sort((a, b) => a - b);
};

const esObligatorio = (f) => f.obligatorio === true || f.obligatoria === true || f.obligatoria === 'R';

// El backend es la única fuente de posiciones, longitudes y obligatoriedad.
// No se muestran los rellenos (nunca llevan dato) ni, en el detalle, las columnas
// que se repetirían en cada rango (RFC y contrato derivados).
export const columnasPm = (campos) => {
  const tabs = Object.fromEntries(Object.values(TAB).map((k) => [k, []]));
  const individuales = campos
    .filter((f) => TAB[f.segmento] && f.clase !== 'relleno' && !(f.segmento === 'DE' && f.clase !== 'dato'))
    .map((f) => {
      const etiqueta = String(f.etiqueta).padStart(2, '0');
      const indice = Number(f.indice);
      const id = `${f.segmento}${etiqueta}`;
      const k = String(f.codigo);
      const fecha = f.tipo === 'F';
      const opts = OPCIONES[id] || (['AC19', 'AV18'].includes(id) ? TIPOS_PERSONA : undefined) || (/Estado$/i.test(f.nombre) ? EDO : (/^Tipo de persona/i.test(f.nombre) ? TIPOS_PERSONA : undefined));
      const dom = (DOMICILIO[f.segmento] || {})[Number(etiqueta)];
      const unidad = f.tipo === 'N' ? 'dígitos' : 'caracteres';
      return {
        k, segmento: f.segmento, indice, etiqueta, label: `${f.nombre}${f.segmento === 'DE' ? ` · ${RANGOS[indice]}` : ''}`,
        // Mismo texto que usan los mensajes de error del backend (AC[2].05, EM.03…).
        num: f.label ? String(f.label).split(' ')[0] : `${f.segmento}${LISTAS.includes(f.segmento) ? `[${indice}]` : ''}.${etiqueta}`,
        maxLength: Number(f.longitud), obligatorio: esObligatorio(f),
        fija: f.clase !== 'dato' || id === 'EM23', kind: id === 'CR05' ? 'decimal' : f.tipo === 'N' ? 'int' : 'text',
        tipo: fecha ? 'fecha' : /RFC/i.test(f.nombre) ? 'rfc' : dom === 'cp' ? 'cp' : undefined, dom,
        opts, w: fecha ? 120 : 170, cl: ['EM', 'AC', 'AV'].includes(f.segmento),
        ayuda: id === 'CR05'
          ? 'Plazo en meses con dos decimales: 036.00.'
          : [AYUDA_PM[id], [OBLIGATORIEDAD[f.obligatoria], f.clase === 'dato' && !fecha ? `Hasta ${f.longitud} ${unidad}.` : null].filter(Boolean).join('. ')].filter(Boolean).join(' ') || undefined,
      };
    })
    .sort((a, b) => Number(a.k) - Number(b.k));
  individuales.forEach((c) => tabs[TAB[c.segmento]].push(c));
  // Las columnas sueltas de cada lista las edita BuroListaEditor.
  const listas = { AC: tabs.accionistas, AV: tabs.avales };
  tabs.accionistas = [{ ...LISTA_COL.AC }];
  tabs.avales = [{ ...LISTA_COL.AV }];
  const tipoPersona = { k: 'tipo_persona', num: '*', label: 'Tipo de persona', col: 0, opts: TIPO, w: 150 };
  tabs.empresa.push(tipoPersona);
  const col = Object.fromEntries([...individuales, tipoPersona].map((c) => [c.k, c]));
  // «Todas»: una columna por lista (no sus 10 posiciones) y el detalle por rango.
  const todas = [tipoPersona, ...tabs.empresa.filter((c) => c !== tipoPersona), tabs.accionistas[0], ...tabs.credito, ...tabs.detalle, tabs.avales[0]];
  return { tabs, todas, col, listas, pestanas: PESTANAS_PM };
};

// Índice código → campo del esquema (null si el reporte no trae `campos`, como PF).
export const indiceCampos = (campos) => (campos && campos.length ? new Map(campos.map((c) => [Number(c.codigo), c])) : null);

/*
 * El armador PM marca fuente 'falta' en TODA celda editable vacía: también las
 * opcionales, las condicionales y las posiciones libres de las listas AC/AV/DE.
 * Eso no es un error: la obligatoriedad la da `campos` y los errores reales vienen
 * en `errores`. Se quita la 'falta' de lo que no es obligatorio y, en una lista, de
 * las entradas que no existen (ninguna de sus celdas tiene valor). Lo demás queda igual
 * (la marca de tipo de persona, 0, y los códigos que `campos` no conoce).
 */
export const fuentesSinFaltasOpcionales = (valores, fuentes, indice) => {
  if (!indice) return fuentes;
  const conDato = new Set(Object.entries(valores || {}).filter(([, v]) => String(v ?? '').trim() !== '').map(([k]) => Math.floor(Number(k) / 100)));
  const out = {};
  Object.entries(fuentes || {}).forEach(([k, v]) => {
    const campo = v === 'falta' ? indice.get(Number(k)) : null;
    if (campo && (!esObligatorio(campo) || (LISTAS.includes(campo.segmento) && !conDato.has(Math.floor(Number(k) / 100))))) return;
    out[k] = v;
  });
  return out;
};
